<template>
  <PageContainer
  >
    <div class="flex flex-col gap-2">
      <!-- TODO: Personalise text based on the type of plan. -->
      <p>This plan is designed to help you {{ planStore?.type }} 😇</p>
      <!-- <p>We’ll complete your mission by slowly moving your bed time to the target 😇</p> -->
      <div v-for="n in planStore?.stageCount" :key="n">
        <div v-if="n === planStore?.activeStageIndex" class="min-w-full py-4 px-8 bg-sky-100 rounded-lg text-left">
          <h3>Stage {{ n }}</h3>
          <p>Each stage lasts one week. Complete this week’s target to progress to the next stage.</p>
          <p>Your target for this stage is:</p>
          <div class="flex flex-col mx-12 p-2 rounded-lg border-2 border-teal-200 bg-theme-teal-bg text-center">
            <div class="">Bed time</div>
            <div class="text-2xl font-bold">{{ formatTime(planStore?.activeStage.target.bedTime) }}</div>
          </div>
          <ol class="relative border-s border-gray-200 mt-4 mx-8">                  
            <li class="text-left mb-4 ms-8">
              <div class="absolute w-6 h-6 bg-gray-200 rounded-full -start-3 border-2 border-sky-100"></div>
              <p class="font-medium">{{ stageStartToday ? 'Today' : ('Day ' + ((7 * n) - 6))}}</p>
              <p class="">Unlock your first sleep tool to try for the week!</p>
            </li>
            <li class="text-left mb-4 ms-8">
              <div class="absolute w-6 h-6 bg-gray-200 rounded-full -start-3 border-2 border-sky-100"></div>
              <p class="font-medium">{{ stageEndToday ? 'Today' : ('Day ' + (7 * n))}}</p>
              <p class="">Get a detailed report and summary your week of sleep.</p>
            </li>
          </ol>
        </div>
        <div v-else-if="n < planStore?.activeStageIndex" class="flex align-center justify-stretch min-w-full py-2 px-8 bg-sky-100 rounded-lg text-left">
          <img src="@/assets/tick.svg" class="h-6">
          <h3 class="w-full text-left ml-4">Stage {{ n }}</h3>
          <div class="flex flex-row p-2 rounded-lg border-[thin] border-teal-200 bg-theme-teal-bg/75 text-center">
            <div class="text-nowrap">
              <!-- <span>Bed time </span> -->
              <span class="font-bold">{{ formatTime(stage(n).target.bedTime) }}</span>
            </div>
          </div>
        </div>
        <div v-else-if="n > planStore?.activeStageIndex" class="flex align-center justify-stretch min-w-full py-2 px-8 bg-sky-100 rounded-lg text-left">
          <img src="@/assets/lock.png" class="h-6">
          <h3 class="w-full text-left ml-4">Stage {{ n }}</h3>
          <div class="flex flex-row p-2 rounded-lg border-[thin] border-gray-200 bg-theme-teal-bg/75 text-center">
            <div class="text-nowrap">
              <!-- <span>Bed time </span> -->
              <span class="font-bold">{{ formatTime(stage(n).target.bedTime) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="flex align-center min-w-full py-2 px-8 rounded-lg border-teal-200 bg-theme-teal-bg border-2 text-left">
        <img src="@/assets/lock.png" class="h-6">
        <h3 class="text-center ml-4">Completion!</h3>
      </div>
    </div>
    <button v-if="stageStart" @click="goToNext()">Start stage {{ planStore?.activeStageIndex }}</button>
    <button v-else @click="goToNext()">Let's do it!</button>
    <!-- TODO: Fix overflow empty space for more than 5 stages. -->
  </PageContainer>
</template>

<script>
import PageContainer from '@/components/PageContainer'
import { time24To12, dateToday } from '@/helpers/time'
import { mapStores } from 'pinia'
import { usePlanStore } from '@/stores/plan'

export default {
  name: 'PlanOutline',
  components: {
    PageContainer,
  },
  props: {
  },
  emits: [
  ],
  data() {
    return {
      modal: true,
      stageStart: false,
      stageStartToday: false,
      stageEndToday: false,
    }
  },
  beforeMount() {
    // Load the plan.
    this.planStore.load()

    // If the stage just started then, show streak start screen.
    const viewed = localStorage.getItem('streak:viewed')
    if (viewed !== dateToday()) {
      this.stageStart = true
    }

    // TODO: Display 'Today'.
    // this.stageStartToday = isSameDate(dateToday(), this.stageActive.startDate)
    // this.stageEndToday = isSameDate(getXDaysAgo(6, dateToday()).start, this.stageActive.startDate)
  },
  watch: {
  },
  methods: {
    stage(index) {
      const reverse = this.planStore.plan?.stages?.toReversed()
      return reverse.find(s => s.index === index)
    },
    formatTime(value) {
      return !value ? '' : time24To12(value)
    },
    goToNext() {
      if (this.stageStart) {
        this.$router.push('/plan/streak')
      } else {
        this.$router.push('/')
      }
    },
  },
  computed: {
    ...mapStores(usePlanStore),
  }
}
</script>